import React from 'react';
import Cta from './Cta';
import '../styles/Header.css'

function Header() {
  return (
    <div className='header'>
        <div><h5>Hello I am</h5></div>
        <div><h1>Anyiekpon</h1></div>
        <div><h5 className='text-light'>Front-End Developer</h5></div>
        <div className='header_cta'>
            <Cta />
        </div>
        
    </div>
  )
}

export default Header